import { useState } from "react";
import { Modal } from "react-bootstrap";

import { InternalButton } from "@sharedComponents/buttons";

import mdStyle from "./use-confirmation-modal.module.scss";

import {
  CONFIRMATION_MODAL_TYPES_HEADER_MAPPING,
  defaultConfirmation,
} from "@constants/confirmation-modal";

const useConfirmationModal = (modalType = defaultConfirmation) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  const onConfirmClick = (onConfirmHandler) => {
    if (onConfirmHandler) onConfirmHandler();
    else toggle();
  };

  const renderConfirmationModal = ({ loading = false, onConfirmHandler = null } = {}) => {
    return (
      <Modal
        data-acsb-overlay="popup"
        show={isOpen}
        animation={false}
        className={`${mdStyle.generalModal} ${mdStyle.confirmModal}`}
        dialogClassName={`${mdStyle.modalDialog}`}
      >
        <Modal.Header className={`${mdStyle.header}`}>
          <h1 className={mdStyle.modalHeading}>Remove Items</h1>
          <i className={`${mdStyle.closeIcon}`} onClick={toggle} />
        </Modal.Header>
        <Modal.Body className={`${mdStyle.modalBody}`}>
          <p className={mdStyle.pTag}>{CONFIRMATION_MODAL_TYPES_HEADER_MAPPING[modalType]}</p>
        </Modal.Body>
        <Modal.Footer className={mdStyle.modalFooter}>
          <InternalButton
            className={mdStyle.actionButton}
            isLoading={loading}
            onClick={() => onConfirmClick(onConfirmHandler)}
            styleType="primary"
          >
            Yes, remove all
          </InternalButton>
        </Modal.Footer>
      </Modal>
    );
  };

  return { toggleConfirmationModal: toggle, renderConfirmationModal };
};

export default useConfirmationModal;
